export function isAgentChatThreadNotFoundError(error: unknown) {
  const message = error instanceof Error ? error.message : "";
  if (!message) {
    return false;
  }

  let body: unknown;
  try {
    body = JSON.parse(message);
  } catch {
    return false;
  }

  return isRecord(body) && isRecord(body.error) && body.error.code === "not_found";
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
